import { EasingFunctions } from '../utils/easing';

/**
 * A transition is an animation between two states.
 * It only runs once. If you need something that keeps running
 * while a component is in a certain state see the
 * useSteppedAnimation hook.
 */
export const useSteppedTransition = ({
  duration = 4,
  steps = 15,
  easingFunction
} = {}) => {
  const fn =
    typeof easingFunction === 'function'
      ? easingFunction
      : EasingFunctions[easingFunction] || EasingFunctions.stepInOutCubic;
  return {
    duration,
    ease: fn(steps)
  };
};
